var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"burger-menu-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"24","viewBox":"0 0 36 24"}},[_c('path',{attrs:{"d":"M0 24V20H36V24H0ZM0 14V10H36V14H0ZM0 4V0H36V4H0Z","fill":"#D9D9D9"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }